import moment from 'moment'

export default {
    findPendingRequests(uid) {
        return {
            size: 1000,
            "query": {
                "bool": {
                    "must": [
                        {
                            "range": {
                                "sender.update_date._seconds": {
                                    "gte": moment().valueOf() / 1000,
                                }
                            }
                        },
                        {
                            "range": {
                                "receiver.update_date._seconds": {
                                    "gte": moment().valueOf() / 1000,
                                }
                            }
                        },
                        {
                            "term": {
                                "status": "pending"
                            }
                        },
                        {    
                            "term": {
                                "receiver.uid": uid
                            }
                        }
                    ]    
                }
            }
        }
    },
    findActualConfirmedRequests(uid) {
        return {
            size: 1000,
            query: {
                bool: {
                    must: [
                        {
                            bool: {
                                should: [
                                    {
                                        bool: {
                                            must: [
                                                {
                                                    term: {
                                                        "sender.uid": uid
                                                    },
                                                },
                                                {
                                                    range: {
                                                        'receiver.update_date._seconds': {
                                                            gte: Date.now()/1000
                                                        }
                                                    }    
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        bool: {
                                            must: [
                                                {
                                                    term: {
                                                        "receiver.uid": uid
                                                    },
                                                },
                                                {
                                                    range: {
                                                        'sender.update_date._seconds': {
                                                            gte: Date.now()/1000
                                                        }
                                                    }    
                                                }
                                            ]
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            bool: {
                                must: [
                                    {
                                        match: {
                                            status: "accepted"
                                        }
                                    }                                    
                                ]
                            }   
                        }
                    ]
                }   
            }
        }
    }
}